<template>
    <tr :class="[style['mds-data-table__row'], classObject, addClass]" :style="inlineStyle">
        <td :class="[style['mds-data-table__cell-selection']]" v-if="multiSelect">
            <div>
                <mds-checkbox
                    :ref="`checkbox${rowIndex}`"
                    :hidden-label="true"
                    :label="rowData[headerConfigs[0].fieldName]"
                    :value="`${id}`"
                    v-model="rowData.selected"
                    @change="onRowSelect"
                />
            </div>
        </td>
        <td :class="[style['mds-data-table__cell-numbered']]" v-if="rowNumber">
            <span :class="[style['mds-data-table__cell--item']]">{{ rowIndex + 1 }}</span>
        </td>
        <slot>
            <mds-data-table-cell
                v-for="(col, cIndex) in headerConfigs"
                :key="cIndex"
                ref="cell"
                :header-config="col"
                :cell-data="rowData[col.fieldName]"
            >
                <slot name="body-cell" :headerConfig="col" :rowData="rowData" :colIndex="cIndex" :rowIndex="rowIndex" />
            </mds-data-table-cell>
        </slot>
    </tr>
</template>

<script>
    import MdsCheckbox from '@mds/checkbox';
    import MdsDataTableCell from './data-table-cell.vue';

    export default {
        name: 'MdsDataTableRow',
        components: {
            MdsCheckbox,
            MdsDataTableCell,
        },
        props: {
            id: {
                type: [String, Number],
                required: true,
            },
            headerConfigs: {
                type: Array,
            },
            rowData: {
                type: Object,
            },
            rowIndex: {
                type: Number,
                default: NaN,
            },
        },
        inject: ['bodyVariation'],
        computed: {
            classObject() {
                const obj = {};
                obj[this.style['mds-data-table__row--selected']] = this.selected;
                obj[this.style['mds-data-table__row--hovered']] = this.isHover;

                return obj;
            },
            addClass() {
                const obj = {};
                const newClass = this.style[this.rowData.class] ? this.style[this.rowData.class] : this.rowData.class;
                obj[newClass] = this.rowData.class;

                return obj;
            },
            multiSelect() {
                return this.bodyVariation && this.bodyVariation.multiSelect;
            },
            rowNumber() {
                return this.bodyVariation && this.bodyVariation.rowNumber;
            },
            responsive() {
                return this.bodyVariation && this.bodyVariation.responsive;
            },
            inlineStyle() {
                return this.rowData.style;
            },
        },
        data() {
            return {
                isHover: false,
                selected: this.rowData.selected,
                style: this.bodyVariation.style,
            };
        },
        methods: {
            onRowSelect(checked) {
                this.selected = checked;
                this.emitRowSelectionChange();
            },
            emitRowSelectionChange() {
                const obj = {};
                obj.checked = this.selected;
                obj.id = this.id;
                this.$emit('mds-data-table-row-selection-change', obj);
            },
        },
        mounted() {
            if (this.rowData.selected) {
                this.selected = this.rowData.selected;
                this.emitRowSelectionChange();
            }
        },
        updated() {
            if (this.rowData.selected !== this.selected) {
                this.selected = this.rowData.selected;
                this.emitRowSelectionChange();
            }
        },
    };
</script>
